import { Directive, Input } from '@angular/core';

@Directive( {
  selector : '[prevent-keys]',
  host : {
      '(keydown)' : 'onKeyUp($event)'
  }
} )
export class PreventKeyseDirective {
  @Input( 'prevent-keys' ) preventKeys;
  onKeyUp ( $event ) {
      if ( this.preventKeys && this.preventKeys.includes( $event. keyCode ) ) {
          $event.preventDefault();
      }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/directives/prevent-keys.directive.ts